import { render } from "./carnetRev2.vue?vue&type=template&id=04efb664&scoped=true"
import script from "./carnetRev2.vue?vue&type=script&lang=js"
export * from "./carnetRev2.vue?vue&type=script&lang=js"

import "./carnetRev2.vue?vue&type=style&index=0&id=04efb664&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04efb664"]])

export default __exports__